module.exports = __webpack_public_path__ + "assets/img/15.f7cfdd3b.png";